import {useEffect, useState} from 'react';
import {postAuthAuthenticatorVerify} from 'api/auth';
import {useAuth} from 'contexts/AuthContext';
import {alertByError} from 'utils/alerts';

function useVerifyEmailGuard() {
  const [isVerifying, setIsVerifying] = useState(false);
  const {setSession} = useAuth();

  useEffect(() => {
    return () => setIsVerifying(false);
  }, []);

  async function verifyEmailGuard(formData) {
    setIsVerifying(true);
    try {
      const {data} = await postAuthAuthenticatorVerify(formData);
      const {session_id, account, consent, permission} = data;

      await setSession({token: session_id, account, consent, permission}, true);
      setIsVerifying(false);
    } catch (e) {
      setIsVerifying(false);
      await alertByError(e);
    }
  }

  return {isVerifying, onVerify: verifyEmailGuard};
}

export default useVerifyEmailGuard;
